module.exports = __webpack_public_path__ + "img/home_slide6.632d2286.jpg";